import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import { useVault } from '../context/VaultContext';

export function useCollectionStats() {
  const { activeVaultId } = useVault();

  return useQuery({
    queryKey: ['collection-stats', activeVaultId],
    queryFn: () => apiClient.getCollectionStats(activeVaultId ?? undefined),
  });
}
